<template>
<div>
    <trademark-opposition-form ref="trademarkOppositionFormModal"></trademark-opposition-form>
    <trademark-form ref="trademarkFormModal"></trademark-form>
    <context-menu ref="copyMenu"></context-menu>
    <b-modal id="agentTransactionsReportTrademarkOppositionModal" centered size="xl" no-close-on-backdrop ref="agentTransactionsReportTrademarkOppositionModal" :title="this.titleText + ' - ' + $t('agentTransactionsReportTrademarkOpposition.title')" hide-footer @close="clear()">
        <!-- table -->
        <b-row>
            <b-col class="col-md-12 mb-1 custom-search d-flex justify-content-end">
                <div class="d-flex align-items-right">
                    <b-button style="float:right;" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
                </div>
            </b-col>
        </b-row>
        <vue-good-table id="agentTransactionsReportTrademarkOppositionTable" ref="agentTransactionsReportTrademarkOppositionTable" :columns="filteredColumns" :rows="rows" styleClass="vgt-table condensed tableSize" :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }" :search-options="{
          enabled: true,
          externalQuery: searchTerm }" :pagination-options="{
          enabled: true,
          perPage:pageLength
        }">
            <div slot="emptystate">
                {{ $t('dataTable.data_not_found') }}
            </div>
            <!-- Row: Table Row -->
            <template slot="table-column" slot-scope="props">
                <span v-if="props.column.field === 'name'" class="text-nowrap">
                    <span>
                        {{ $t('agentTransactionsReportTrademarkOpposition.name') }}
                        <br>
                        {{ $t('agentTransactionsReportTrademarkOpposition.owner') }}
                    </span>
                </span>
            </template>
            <!-- Column: Table Column -->
            <template slot="table-row" slot-scope="props">
                <!-- Column: Logo -->
                <span v-if="props.column.field === 'logo'" class="text-nowrap">
                    <b-row>
                        <b-col v-if="props.row.logo != null" class="font-size: x-small">
                            <b-img>{{ 'data:image/jpeg;base64,'.concat(props.row.logo) }}</b-img>
                            <b-img :src="'data:image/jpeg;base64,'.concat(props.row.logo)" fluid alt="Responsive image" />
                        </b-col>
                    </b-row>
                </span>
                <span v-else-if="props.column.field === 'recordNo'">
                    <b-row>
                        <b-col class="font-size: x-small">
                            <b-badge @contextmenu.prevent="openContextMenu($event, props.row.recordNo)" @click="showTrademarkOppositionInfoForm(props.row)" variant="primary" style="cursor: pointer;">
                                <feather-icon icon="MousePointerIcon" class="mr-25" />
                                <span>{{ props.row.recordNo }}</span>
                            </b-badge>
                        </b-col>
                    </b-row>
                </span>
                <span v-else-if="props.column.field === 'applicationNo'">
                    <b-row>
                        <b-col class="font-size: x-small">
                            <span>
                                {{ props.row.applicationNo }}
                            </span>
                        </b-col>
                    </b-row>
                </span>
                <span v-else-if="props.column.field === 'name'">
                    <b-row>
                        <b-col class="font-size: x-small">
                            <span>
                                {{ props.row.name }}
                            </span>
                            <br>
                            <span style="font-weight: bold;">
                                {{ props.row.holderName }}
                            </span>
                        </b-col>
                    </b-row>
                </span>
                <span v-else-if="props.column.field === 'date'">
                    <b-row>
                        <b-col class="font-size: x-small">
                            <span>
                                {{ $formatFn(props.row.date) }}
                            </span>
                        </b-col>
                    </b-row>
                </span>
                <span v-else-if="props.column.field === 'ownerList'">
                    <b-col>
                        <b-row v-for="owner in props.row.ownerList" v-bind:key="owner.clientName" style="font-size: small;">
                            <tr v-if="props.row.ownerList.length != 1">
                                <feather-icon class="featherIconReSize" icon="ArrowRightIcon" />
                                <span>{{ owner.clientName }} </span> <br />
                            </tr>
                            <tr v-else-if="props.row.ownerList.length == 1">
                                <span>{{ owner.clientName }} </span> <br />
                            </tr>
                        </b-row>
                    </b-col>
                </span>
                <span v-else-if="props.column.field === 'basisForOppositionList'">
                    <b-col>
                        <b-row v-for="basisForOpposition in props.row.basisForOppositionList" v-bind:key="basisForOpposition.id" style="font-size: small;">
                            <tr>
                                <b-badge @contextmenu.prevent="openContextMenu($event, props.row.recordNo)" @click="showTrademarkInfoForm(basisForOpposition.trademarkId)" variant="primary" style="cursor: pointer;">
                                    <feather-icon icon="MousePointerIcon" class="mr-25" />
                                </b-badge>
                                <span>{{ basisForOpposition.name }} </span>
                            </tr>
                        </b-row>
                    </b-col>
                </span>
                <span v-else-if="props.column.field === 'trademarkOppositionStatus'">
                    <b-row>
                        <b-col class="font-size: x-small">
                            <span>
                                {{ props.row.trademarkOppositionStatus }}
                            </span>
                        </b-col>
                    </b-row>
                </span>
            </template>
            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}
                        </span>
                        <b-form-select v-model="pageLength" :options="['10', '50', '100', '1000']" class="mx-1" @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                        <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                    </div>
                    <div>
                        <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => props.pageChanged({ currentPage: value })">
                            <template #prev-text>
                                <feather-icon icon="ChevronLeftIcon" size="18" />
                            </template>
                            <template #next-text>
                                <feather-icon icon="ChevronRightIcon" size="18" />
                            </template>
                        </b-pagination>
                    </div>
                </div>
            </template>
        </vue-good-table>
    </b-modal>
</div>
</template>

<script>
import { clear } from 'echarts/lib/util/throttle';

export default {
    data() {
        return {
            total: 0,
            pageLength: 50,
            dir: false,
            pageNo: 1,
            columns: [{
                    label: this.$t('agentTransactionsReportTrademarkOpposition.logo'),
                    field: `logo`,
                },
                {
                    label: this.$t('agentTransactionsReportTrademarkOpposition.referance_no'),
                    field: 'recordNo',
                },
                {
                    label: this.$t('agentTransactionsReportTrademarkOpposition.application_no'),
                    field: 'applicationNo',
                },
                {
                    label: this.$t('agentTransactionsReportTrademarkOpposition.date'),
                    field: 'date',
                },
                {
                    label: this.$t('agentTransactionsReportTrademarkOpposition.name'),
                    field: 'name',
                },
                {
                    label: this.$t('agentTransactionsReportTrademarkOpposition.agent'),
                    field: 'agent',
                },
                {
                    label: this.$t('agentTransactionsReportTrademarkOpposition.owners'),
                    field: 'ownerList',
                },

                {
                    label: this.$t('agentTransactionsReportTrademarkOpposition.basisForOpposition'),
                    field: 'basisForOppositionList',
                },
                {
                    label: this.$t('agentTransactionsReportTrademarkOpposition.nice_class'),
                    field: 'niceClass',
                },
                {
                    label: this.$t('agentTransactionsReportTrademarkOpposition.status'),
                    field: 'trademarkOppositionStatus',
                }
            ],
            rows: [],
            searchTerm: '',
            isAgent: false,
            isOwner: false,
            name: '',
            titleText: '',
            clientAccountingId: 0,
            clientId: 0,
        }
    },
    computed: {
        filteredColumns() {
            return this.columns.filter(col => {
                if (col.field === 'agent') {
                    return !(this.clientId == 0 && this.clientAccountingId != 0);
                }
                if (col.field === 'ownerList') {
                    return !(this.clientId > 0 && this.clientAccountingId == 0);
                }
                return true;
            });
        }
    },
    methods: {
        clear() {
            this.rows = []
            this.clientAccountingId = 0
            this.clientId = 0
            this.titleText = ''
        },
        openContextMenu(event, row) {
            this.$refs.copyMenu.openContextMenu(event, row)
        },
        showTrademarkInfoForm(trademarkId) {
            this.$refs.trademarkFormModal.showInfo(trademarkId)
        },
        showTrademarkOppositionInfoForm(row) {
            this.$refs.trademarkOppositionFormModal.showInfo(row.id)
        },
        getAgentTransactionsReportList(recordType, clientAccountingId) {
            this.$refs.agentTransactionsReportTrademarkOppositionModal.show()
            this.rows = []
            this.clientAccountingId = clientAccountingId
            const data = {
                recordType: recordType,
                clientAccountingId: clientAccountingId
            }
            const controller = {
                name: 'Client',
                actionName: 'AgentTransactionsReportDetail'
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.titleText = response.data.titleText
                    this.rows = response.data.trademarkOppositionList
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
        getOwnerTransactionsReportList(recordType, clientId) {
            this.$refs.agentTransactionsReportTrademarkOppositionModal.show()
            this.rows = []
            this.clientId = clientId
            const data = {
                recordType: recordType,
                clientId: clientId
            }
            const controller = {
                name: 'Client',
                actionName: 'AgentTransactionsReportDetail'
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.titleText = response.data.titleText
                    this.rows = response.data.trademarkOppositionList
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
        exportExcel() {
            const controller = {
                name: 'Client',
                actionName: 'CanAgentExcelReport'
            }
            const data = {
                columnList: this.filteredColumns,
                DataList: this.rows
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("Tüm İşlemler Raporu", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    },
}
</script>

<style>
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
